export const API_ENDPOINT_RECONCILATION_FETCH_GST_DATA = `${process.env.REACT_APP_API_URL}/recon/hotel`;
export const API_ENDPOINT_RECONCILATION_FETCH_AIRLINE_DATA = `${process.env.REACT_APP_API_URL}/recon/airline`;
export const API_ENDPOINT_RECONCILATION_FETCH_DOWNLOAD_HISTORY = `${process.env.REACT_APP_API_URL}/agtable/report/request/`;
export const API_ENDPOINT_RECONCILATION_RAISE_RECON_REQUEST = `${process.env.REACT_APP_API_URL}/agtable/report/request`;
